import React, { useEffect, useState } from "react";
import Headerstatic from "./Headerstatic";
import Footer from "./Footer";
import axios from "axios";

function Privacypolicy() {

  const [data16, setdata16] = useState([]);

  const [data17, setdata17] = useState([]);

  const [data18, setdata18] = useState([]);

  useEffect(() => {
    datas();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const api_url = "https://icreatedegreecollege.com/api";

  const datas = () => {
    axios
      .post("https://icreatedegreecollege.com/api/api/web/landing/getitems", {}, {})
      .then(
        (res) => {
          if (res.status === 200) {
            setdata16(res.data.certificateResult);
            setdata17(res.data.ratingResult);
            setdata18(res.data.contactInfoResult[0]);
          }
        },
        (error) => {
          if (error.response && error.response.status === 400) {
            console.log(error.response.data.message);
          }
        }
      );
  };



  return (
    <div>
      <Headerstatic />
      <div className="container">
        <div class="cardpad mt-3 pt-3 mt-md-5 pt-md-5">
          <div className="text-center text-primary pt-5">
            <h3 style={{ color: "#12498b" }} >Privacy Policy</h3>
          </div>
          <h5 className="mt-3 mt-md-5">PLEASE READ THE FOLLOWING CAREFULLY</h5>
          <p>
            This statement provides general information about the privacy statement of this website and its related presence on all digital platforms.
          </p>
          <p>
            It is intended to inform you of the ways in which this website collects information, the use of that information and the ways in which icreate degree college will protect any information you choose to provide.
          </p>
          <p>
            Our data privacy policy strictly conforms to the international legal regulations set down in accordance to the protection of data collected from people visiting our website.
          </p>
          <p>
            icreate degree college treats all personal data obtained via internet and our website carefully and confidentially so that no information is tampered, with regard to the collected data .
          </p>
          <p>
            Personal data will be kept secret, privacy will be respected and information will be used exclusively for the purpose for which it was made known to us.
          </p>
          <p>
            Without seeking approval of the respective person, this data will neither be made accessible to third parties, nor transferred to them in any form or manner.
          </p>
        </div>
      </div>
      <Footer data16={data16} data17={data17} data18={data18} />
    </div>
  );
}

export default Privacypolicy;
